import React, { useState, useEffect } from "react";
import { Tab } from "semantic-ui-react";
import "./StudentModal.scss";
import { NewStudentForm } from "../NewStudentForm";
import { ReentryStudentForm } from "../ReentryStudentForm";
import { BulkImportStudentForm } from "../BulkImportStudentForm";
import { PaymentCategory, Grade } from "../../../../api";
import { useAuth } from "../../../../hooks";

const gradeController = new Grade();
const paymentCategoryController = new PaymentCategory();

export function StudentModal(props) {
  const { onClose, academicCycle, onReload, grades } = props;
  const { accessToken } = useAuth();
  const [activeIndex, setActiveIndex] = useState(0);
  const [gradesOptions, setGradesOptions] = useState([]);
  const [paymentCategoriesOptions, setPaymentCategoriesOptions] = useState([]);
  const [student, setStudent] = useState(null);

  useEffect(() => {
    if (grades && grades.length > 0) {
      const options = grades.map((grade) => ({
        value: grade.id,
        text: grade.name,
      }));
      setGradesOptions(options);
    }
  }, [grades]);

  useEffect(() => {
    (async () => {
      try {
        setPaymentCategoriesOptions([]);
        const response = await paymentCategoryController.getPaymentCategories(
          accessToken
        );
        const options = response.map((paymentCategory) => ({
          value: paymentCategory.id,
          text: paymentCategory.name,
        }));
        setPaymentCategoriesOptions(options);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [accessToken]);

  const panes = [
    {
      menuItem: "Matrícula",
      render: () => (
        <Tab.Pane>
          <NewStudentForm
            onClose={onClose}
            onReload={onReload}
            academicCycle={academicCycle}
            gradesOptions={gradesOptions}
            paymentCategoriesOptions={paymentCategoriesOptions}
            student={student}
          />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Reingreso",
      render: () => (
        <Tab.Pane>
          <ReentryStudentForm
            onClose={onClose}
            onReload={onReload}
            academicCycle={academicCycle}
            gradesOptions={gradesOptions}
            paymentCategoriesOptions={paymentCategoriesOptions}
          />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Carga masiva",
      render: () => (
        <Tab.Pane>
          <BulkImportStudentForm
            onClose={onClose}
            onReload={onReload}
            academicCycle={academicCycle}
            gradesOptions={gradesOptions}
          />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div className="student-modal">
      <Tab
        panes={panes}
        className="student__forms"
        activeIndex={activeIndex}
        onTabChange={(_, data) => setActiveIndex(data.activeIndex)}
      />
    </div>
  );
}
